import { atom } from "jotai";

export const isVideoCallUiOpenAtom = atom(false);
